<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/x7HiTG/tc-custom/9780802147370.jpg?1728954790368" alt="This image is the cover for the book Their Little Secret, The Tom Thorne Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Their Little Secret, The Tom Thorne Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman’s suicide puts a detective on the trail of a cold-hearted con artist: “Outstanding . . . a maximum of suspense” (<i>Publishers Weekly</i>, starred review).</b><br/>  <br/> When DI Tom Thorne is called to the site of a suicide, he expects to be in and out in no time. But when he arrives at the Underground station where a woman named Philippa Goodwin threw herself in front of a train, he inexplicably senses something awry and feels compelled to dig deeper. He soon discovers that she was the victim of a callous con man who preys on vulnerable women—and whose deception plunged Philippa to her end.<br/>  <br/> Thorne enlists DI Nicola Tanner to help him track down the swindler and bring him to justice. But the detective duo gets more than they bargained for when a young man’s bludgeoned body turns up on the shore of a nearby seaside town and the two cases come together in a way that neither of the detectives could have foreseen . . .<br/>  <br/> “A fantastic thriller . . . a gripping plot and lead characters of remarkable depth. Billingham is a multiple-award winner, and his books have sold more than six million copies. Readers who grab this one but aren’t familiar with its predecessors will be seeking them out. A series to savor.” ―<i>Booklist</i> (starred review)<br/>  <br/> “Billingham is a world-class writer and Tom Thorne is a wonderful creation.” ―Karin Slaughter, bestselling author of the Will Trent series
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Billingham
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Atlantic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?efabdafe